// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"624":"Requirements","4764":"RequirementsGroup"}[chunkId] + "." + {"624":"86e94555","4764":"86e94555"}[chunkId] + ".chunk.css";
};